// Product Bundle and Single Product Bundle Start
jQuery(function($) {
  var bundleArray = [];
  var productTitle ="";
  var variantId = "";
  var quantity = 0;

  $('table .quantity:first').focus();
  $('[max]').change(function() {
    var max = parseInt($(this).attr('max'), 10);
    var value = parseInt($(this).val(), 10) || 0;
    if (value > max) { 
      $(this).val(max); 
    }    
  });

  $( ".add-btn" ).on( "click", function() {
    $( this ).parents('.bundle-btns').find(".btn-qty" ).show();
    var currentQty = parseInt($( this ).parents('.bundle-btns').find("[qty-field]").val());
    var maxStock = parseInt($( this ).parents('.bundle-btns').find("[qty-field]").attr('max'));

    if (currentQty >= maxStock) {
      $( this ).parents('.bundle-btns').find("[qty-field]").val(maxStock);
      $( this ).text(maxStock + ' added');

      //       single Bundle Start
      variantId = $( this ).parents('.bundle-btns').attr('variant-id');
      productTitle = $( this ).parents('.bundle-btns').attr('product-title');
      quantity = $( this ).parents('.bundle-btns').find("[qty-field]").attr('max');
      addProduct(variantId, productTitle, quantity);
      //       single Bundle End

      $( this ).parents('.bundle-btns').find( '.bundle-error' ).html( '<span class="error-message">We have '+ maxStock + ' in stock.</span>' );
    } else {
      $( this ).parents('.bundle-btns').find("[qty-field]").val(currentQty + 1);
      $( this ).text(currentQty + 1 + ' added');
      $( this ).parents('.bundle-btns').find( '.bundle-error' ).html( '' );

      //       single Bundle Start
      variantId = $( this ).parents('.bundle-btns').attr('variant-id');
      productTitle = $( this ).parents('.bundle-btns').attr('product-title');
      quantity = $( this ).parents('.bundle-btns').find("[qty-field]" ).val();;
      addProduct(variantId, productTitle, quantity);
      //       single Bundle End
    }
    addtocartEnable ();

  });

  $( ".plus-qty" ).on( "click", function() {
    var currentQty1 = parseInt($( this ).parents('.bundle-btns').find("[qty-field]" ).val());
    var maxStock1 = parseInt($( this ).parents('.bundle-btns').find("[qty-field]" ).attr('max'));

    if (currentQty1 >= maxStock1) { 
      $( this ).parents('.bundle-btns').find("[qty-field]" ).val(maxStock1);
      $(this).parents('.bundle-btns').find('.add-btn').text(maxStock1 + ' added');

      //       single Bundle Start
      variantId = $( this ).parents('.bundle-btns').attr('variant-id');
      productTitle = $( this ).parents('.bundle-btns').attr('product-title');
      quantity = $( this ).parents('.bundle-btns').find("[qty-field]").attr('max');
      addProduct(variantId, productTitle, quantity);
      //       single Bundle End

      $( this ).parents('.bundle-btns').find( '.bundle-error' ).html( '<span class="error-message">We have '+ maxStock1 + ' in stock.</span>' );
    } else {
      $( this ).parents('.bundle-btns').find("[qty-field]" ).val(currentQty1 + 1);
      $(this).parents('.bundle-btns').find('.add-btn').text(currentQty1 + 1 + ' added');
      $( this ).parents('.bundle-btns').find('.bundle-error').html( '' );

      //       single Bundle Start
      variantId = $( this ).parents('.bundle-btns').attr('variant-id');
      productTitle = $( this ).parents('.bundle-btns').attr('product-title');
      quantity = $( this ).parents('.bundle-btns').find("[qty-field]" ).val();
      addProduct(variantId, productTitle, quantity);
      //       single Bundle End

    }

    addtocartEnable ();

  });

  $( ".minus-qty" ).on( "click", function() {
    var currentQty2 = parseInt($( this ).parents('.bundle-btns').find("[qty-field]" ).val());

    if (currentQty2 <= 1) {
      $( this ).parents('.bundle-btns').find("[qty-field]" ).val(0);
      $(this).parents('.bundle-btns').find('.add-btn').text('Add');
      $( this ).parents('.bundle-btns').find('.btn-qty').hide();

      //       single Bundle Start
      variantId = $( this ).parents('.bundle-btns').attr('variant-id');
      productTitle = $( this ).parents('.bundle-btns').attr('product-title');
      quantity = $( this ).parents('.bundle-btns').find("[qty-field]" ).val();
      removeProduct(variantId, productTitle, quantity);
      //       single Bundle End
    } else {
      $( this ).parents('.bundle-btns').find("[qty-field]" ).val(currentQty2 - 1);
      $(this).parents('.bundle-btns').find('.add-btn').text(currentQty2 - 1 + ' added');
      $( this ).parents('.bundle-btns').find('.bundle-error').html( '' );

      //       single Bundle Start
      variantId = $( this ).parents('.bundle-btns').attr('variant-id');
      productTitle = $( this ).parents('.bundle-btns').attr('product-title');
      quantity = $( this ).parents('.bundle-btns').find("[qty-field]" ).val();
      removeProduct(variantId, productTitle, quantity);
      //       single Bundle End
    }
    addtocartEnable ();
  });

  function addtocartEnable (){
    var bundleLimit = $('.bundle-limit').val();
    var productCount = 0;

    $(".bundle-btns [qty-field]").each(function() {
      productCount += parseInt($(this).val());
    });
    $( '.bundle-count' ).html( 'There is '+ productCount +' product in your bundle.' );

    if( bundleLimit > productCount ){
      $('.bundle-addtocart').prop('disabled', true);
      $(".add-btn, .plus-qty").removeAttr('disabled');
    }else if(bundleLimit == productCount ) {

      $(".bundle-addtocart").removeAttr('disabled');
      $('.add-btn, .plus-qty').prop('disabled', true);
    } else {

    }
  }


  //       single Bundle Start 
  $('.single-bundle-addtocart').prop('disabled', true);

  function addProduct(variant, title, qty) {
    if(bundleArray.length === 0) {
      bundleArray.push({'variant' : Number(variant), 'title' : title, 'qty' : Number(qty)});
    } else {
      var oldValue = true;
      $.each(bundleArray, function( key, value ) {
        if (value.variant == Number(variant)) {
          value.qty = Number(qty);
          oldValue = false;
        }
      });
      if(oldValue){
        bundleArray.push({'variant' : Number(variant), 'title' : title, 'qty' : Number(qty)});
      }
    }
    createLineItem(bundleArray);
  }

  function removeProduct(variant, title, qty) {
    if(bundleArray.length === 0) {
    } else {
      var check = false;
      var number = 0;
      $.each(bundleArray, function( key, value ) {
        if (value.variant === Number(variant)) {
          if(Number(qty) <= 0){
            check = true;
            number = key;
          }else {
            value.qty = Number(qty);
          }
        }
      });
      if(check){
        bundleArray.splice(number, 1);
      }
    }
    createLineItem(bundleArray);
  }

  function createLineItem(properties) {
    var lineItem = '';
    //     console.log(properties);
    $.each(properties, function( key, value ) {
      lineItem += '<input id="" class="hidden" name="properties['+(key+1)+'. '+value.title+']" value="'+value.qty+'">';
    });
    $('#line-item-properties').html(lineItem);
    addBundleEnable ();
  }

  function addBundleEnable (){
    var bundleLimit = $('.bundle-limit').val();
    var productCount = 0;

    $(".bundle-btns [qty-field]").each(function() {
      productCount += parseInt($(this).val());
    });
    $( '.single-bundle-count' ).html( 'There is '+ productCount +' product in your bundle.' );

    if( bundleLimit > productCount ){
      $('.single-bundle-addtocart').prop('disabled', true);
      $(".add-btn, .plus-qty").removeAttr('disabled');
    }else if(bundleLimit == productCount ) {

      $(".single-bundle-addtocart").removeAttr('disabled');
      $('.add-btn, .plus-qty').prop('disabled', true);
    } else {

    }
  }
  //       single Bundle End
});
// Product Bundle and Single Product Bundle End